
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 28.6h14.3v42.8H0zM85.7 28.6H100v42.8H85.7zM28.6 85.7h42.8V100H28.6zM28.6 0h42.8v14.3H28.6zM14.3 14.3h14.3v14.3H14.3zM71.4 71.4h14.3v14.3H71.4zM71.4 14.3h14.3v14.3H71.4zM14.3 71.4h14.3v14.3H14.3zM57.1 42.8h14.3v14.3H57.1zM42.8 28.6h14.3v14.3H42.8zM42.8 57.1h14.3v14.3H42.8z"}})])
          )
        }
      }
    